import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { type ManagementCardInfo } from './types';

export const ManagementCard: React.FunctionComponent<ManagementCardInfo> = (
  props: ManagementCardInfo,
) => {
  const { title, caseField, caseName, caseNumber, backgroundColor, navLink } =
    props;

  const handleCardClick = (): void => {
    window.location.href = `${navLink}`;
  };

  return (
    <Card
      sx={{
        minWidth: 300,
        minHeight: 180,
        padding: '0.25rem',
        backgroundColor: backgroundColor ?? '#951D1D',
        margin: '1.5rem',
        cursor: 'pointer',
        boxShadow: '2px 3px 8px 1px rgba(0, 0, 0, 0.25)',
      }}
      onClick={handleCardClick}
    >
      <CardContent
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'white' }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: '1rem',
            color: 'white',
          }}
        >
          {caseField === undefined ? (
            <>
              {caseName}
              {caseName !== undefined ? ': ' : ''}
              {caseNumber}
            </>
          ) : (
            <>{caseField}</>
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};
